import { httpsCallable } from 'firebase/functions'
import { functionsAsia } from '~~/firebaseConfig'
import { parseAIAnalysis } from './aiAnalysis'

export async function requestAIAnalysis(kind: 'campaign' | 'creator' | 'advertiser', text: string) {
  const call = httpsCallable<
    { kind: typeof kind, text: string },
    { keywords: string[], analyzedAt: string }
  >(functionsAsia, 'analyzeMarketingProfile', { timeout: 65000 })
  const { data } = await call({ kind, text })
  const result = parseAIAnalysis(JSON.stringify(data))
  if (typeof data.analyzedAt !== 'string' || !Number.isFinite(Date.parse(data.analyzedAt)))
    throw new Error('AI analysis returned an invalid timestamp.')
  return { ...result, analyzedAt: data.analyzedAt }
}
